import { Plus, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  onAddRule: () => void;
  onOpenImport: () => void;
}

export function EmptyState({ onAddRule, onOpenImport }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed p-12 text-center">
      <h3 className="text-lg font-medium">Noch keine Scoring-Regeln</h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        Scoring-Regeln verbinden Quiz-Antworten mit Produkt-Tags. Beginne mit
        einer neuen Regel oder importiere Regeln aus einer CSV-Datei.
      </p>
      <div className="mt-6 flex gap-2">
        <Button type="button" size="sm" onClick={onAddRule}>
          <Plus className="mr-2 h-4 w-4" />
          Erste Regel hinzufügen
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onOpenImport}
        >
          <Upload className="mr-2 h-4 w-4" />
          CSV importieren
        </Button>
      </div>
    </div>
  );
}
